import { ActionIcon, Button, Stack, Tooltip } from "@mantine/core";
import { IconDotsVertical } from "@tabler/icons-react";
import PopOver from "../../../components/View/PopOver";
import { useLanguage } from "../../../stores/LanguageStore";
import { useNavigate, useParams } from "react-router-dom";
import ItemDeleter from "../../../components/TableComponents/ItemDeleter";
import ItemRemoveFromFolder from "../../../components/TableComponents/ItemRemoveFolder";
import { deleteAgent, editAgent } from "../../../api/AgentsAPI";

const AgentActions = ({ current, inside = false, setLoading }) => {
  const lang = useLanguage((s) => s.language);
  const { agentId, folderId } = useParams();

  const navigate = useNavigate();
  const handleDeleteDone = (handleClose) => {
    if (agentId === current.id.toString()) {
      navigate(folderId ? `/agents/folder/${folderId}/none` : `/agents/none`);
    }
    handleClose();
    setLoading(true);
  };

  return (
    <PopOver
      opener={(handleOpen, ref) =>
        inside ? (
          <Button
            ref={ref}
            variant="light"
            color="primary"
            leftSection={<IconDotsVertical size={18} />}
            radius={"sm"}
            ml={"auto"}
            onClick={handleOpen}
          >
            {lang.table.more_actions}
          </Button>
        ) : (
          <Tooltip label={lang.table.more_actions}>
            <ActionIcon
              variant="subtle"
              ref={ref}
              color="primary"
              onClick={handleOpen}
            >
              <IconDotsVertical size={18} />
            </ActionIcon>
          </Tooltip>
        )
      }
      popoverChildren={(handleClose) => (
        <Stack gap={0}>
          {folderId && folderId !== "none" && (
            <ItemRemoveFromFolder
              title_bold={`${current.name} #${current.id}`}
              handleEdit={editAgent}
              id={current.uniqid}
              onFinish={() => handleDeleteDone(handleClose)}
              isButton
            />
          )}

          <ItemDeleter
            title_bold={`${current.name} #${current.id}`}
            handleDelete={deleteAgent}
            deletedMessage={"Agent supprimé avec succès"}
            id={current.uniqid}
            disabled={
              !current?.delete_permission &&
              !current?.permission?.delete_permission
            }
            onFinish={() => handleDeleteDone(handleClose)}
            isButton
          />
        </Stack>
      )}
      anchorOrigin={
        inside
          ? { horizontal: "right", vertical: "bottom" }
          : { horizontal: "left", vertical: "center" }
      }
      transformOrigin={
        inside
          ? { horizontal: "right", vertical: "top" }
          : { horizontal: "right", vertical: "center" }
      }
      sx={{ zIndex: "200 !important" }}
    />
  );
};

export default AgentActions;
